import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000',
});

// Función auxiliar para detectar el subdominio
const getTenantId = () => {
  const hostname = window.location.hostname; // ej: 'empresa1.localhost' o 'cocacola.tupolla.com'
  const parts = hostname.split('.');
  
  // Si hay subdominio (ej: empresa1.localhost tiene 2 partes, empresa1.com tiene 2 partes)
  // Esta lógica toma la primera palabra antes del primer punto
  if (parts.length > 1 && parts[0] !== 'www' && parts[0] !== 'localhost') {
    return parts[0];
  }
  return null;
};


// 1. Interceptor para ENVIAR Token y TenantId
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  const tenantId = getTenantId();

  // NUEVO: Enviamos el ID de la empresa en el header que espera NestJS
  if (tenantId) {
    config.headers['x-tenant-id'] = tenantId;
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  return config;
});

// 2. Interceptor para REACCIONAR a errores (Se mantiene igual)
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Sesión expirada o inválida. Redirigiendo al login...");
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;